export enum AnalyticsEvent {
  AllOffersDeclined = "all_offers_declined",
  ApiErrorDisplayed = "api_error_displayed",
  ApplicationChanged = "application_changed",
  ApplicationStageViewed = "application_stage_viewed",
  ChatMessageSent = "chat_message_sent",
  ChatSessionEnded = "chat_session_ended",
  ChatSessionStarted = "chat_session_started",
  CheckoutCompleted = "checkout_completed",
  CheckoutCustomStepUrlVisited = "checkout_custom_step_url_visited",
  CheckoutStarted = "checkout_started",
  CheckoutStepCompleted = "checkout_step_completed",
  CustomTabRedirectClicked = "custom_tab_redirect_clicked",
  DeclineReasonDropdownOpened = "decline_reason_dropdown_opened",
  DocumentDeleted = "document_deleted",
  DocumentEdited = "document_edited",
  DocumentPreviewed = "document_previewed",
  DocumentReplaced = "document_replaced",
  DocumentScreenViewd = "document_screen_viewed",
  DocumentTypeSelectedManually = "document_type_selected_manually",
  DocumentUploadFailed = "document_upload_failed",
  DocumentUploadRetried = "document_upload_retried",
  DocumentUploaded = "document_uploaded",
  DynamicOfferFieldAdjusted = "dynamic_offer_field_adjusted",
  DynamicOfferGroupExpanded = "dynamic_offer_group_expanded",
  EmailConfirmed = "email_confirmed_with_magic_link",
  FeedbackSubmitted = "feedback_submitted",
  FundingAdvisorCalendarOpened = "funding_advisor_calendar_opened",
  FundingAdvisorCalled = "funding_advisor_called",
  LoginAttempted = "login_attempted",
  LoginFailed = "login_failed",
  LogoutClicked = "logout_clicked",
  MagicLinkResent = "magic_link_resent",
  OfferAccepted = "offer_accepted",
  OfferCarouselNavigated = "offer_carousel_navigated",
  OfferDetailsCollapsed = "offer_details_collapsed",
  OfferDetailsExpanded = "offer_details_expanded",
  OfferRejected = "offer_rejected",
  TabClicked = "tab_clicked",
  UnandledErrorThrown = "unhandled_error_thrown",
}
